<i18n lang='yml' src='../i18n/ExamTypeIndex.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          {{ $t('exam_types') }}
        </h4>
        <a v-if="edit_permission == 'true'" class="btn btn-sm btn-success ml-auto" href="exam_types/new">
          <font-awesome-icon :icon="['fas', 'plus']"/>
          {{ $t('new_exam_type') }}
        </a>
      </div>
      <div class="media-list">
 
        <div v-for="(item, index) in examTypeItems" :key="index" class="content-block">
          <div class="post-meta">
            <ul class="list-inline list-annotation">
              <li>
                <h5 class="container-item-name">
                   <a :href="`${base_path}/${item.id}`"> {{ item.name[locale] }} </a>
                </h5>
              </li>
              <li v-if="edit_permission == 'true'" class="ml-auto">
                <div class="btn-group btn-group-sm ml-auto" role="group">
                  <a class="btn btn-outline-primary" :href="`${base_path}/${item.id}/edit`">
                    <font-awesome-icon :icon="['fas', 'edit']"/>
                    <span> {{ $t('edit') }} </span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="examTypes.length == 0">
        <div class="alert alert-warning" role="alert">
          {{ $t('no_data') }}
        </div>
      </div>
      <pagination  @items_changed="setItems" :items="examTypes" :expansion_threshold="expansion_threshold" :pagination_limit="pagination_limit"/>
    </div>
 </div>
</template>

<script>
import Pagination from '../../../../shared/pagination/Pagination.vue';
 export default {
    props: ['locale', 'exam_types', 'filter_params', 'base_path', 'edit_permission', 'pagination_limit', 'expansion_threshold'],
    components: {
       'pagination': Pagination,
    },
    data() {
      return {
        examTypes: [],
        examTypeItems: [],
        loading: false,
        error: false,
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;
      try{
        this.examTypes = JSON.parse(this.exam_types) || [];
      }
      catch(err){
        this.error = true;  
      }
    },
    methods: {
      setItems(items) {
        this.examTypeItems = items
      }
    }
  }
</script>
